export enum EnumRol {
    Administrador = 1,
    Visor = 2,
    Cliente = 3,
    Comercial = 4,
    SuperAdmin = 5
}
